<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: ["dataset"],
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
  computed: {
    chartdata() {
      return {
        labels: this.dataset.map(e => e[0]),
        datasets: [
          {
            data: this.dataset.map(e => e[1]),
            backgroundColor: "#FF9191",
            fill: true,
            cubicInterpolationMode: 'monotone',
            borderColor: "#F5273F",
          },
        ],
      };
    },
    options() {
      return {
        cubicInterpolationMode: 'monotone',
        layout: {
            padding: 2
        },
        legend: {display: false},
        tooltips: {
            enabled: true,
            backgroundColor: '#FCFCFC',

            titleFontColor: '#404040',
            titleFontSize: 14,
            titleFontFamily: "'Chadwick', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",

            bodyFontColor: '#F5273F',
            bodyFontFamily: "'Chadwick', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            bodyFontSize: 20,
          },
        scales: {
          xAxes: [
            {
              display: true,
              grid: {
                  display: false,
              },
              gridLines: { display: false, zeroLineColor: "#ededed", zeroLineWidth: 0, z: 4 },
              ticks: {
                beginAtZero: true,
                display: false
              },
            },
          ],
          yAxes: [
            {
              display: true,
              grid: {
                  
              },
              gridLines: { display: false, zeroLineColor: "#ededed", zeroLineWidth: 0, z: 4 },
              ticks: {
                beginAtZero: true,
                display: false
              },
            },
          ],
        },
      };
    },
  },
};
</script>

<style>
</style>